var map = {
	"./qualidade/1.png": 2734,
	"./qualidade/2.png": 4510,
	"./qualidade/3.png": 1897,
	"./qualidade/4.png": 3066,
	"./qualidade/5.jpeg": 9247,
	"./qualidade/6.jpeg": 2230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9249;